import axios, { CancelToken } from 'axios';
import { ServiceResponse } from '@/OptimusRoutes/interfaces';
import { TrackingHistoryWithEventsDto } from '@/OptimusRoutes/pages/MainMap/types/trackingHistory.types';

export type TrailAndEvents = {
	deviceId: number | string;
	startDateTime: string | Date;
	endDateTime: string | Date;
	isSegmented: boolean;
};

interface ITrackingHistory {
	getTrackingAndEvents: (
		params: TrailAndEvents,
		cancelToken?: CancelToken
	) => Promise<ServiceResponse<TrackingHistoryWithEventsDto>>;
}

class Service implements ITrackingHistory {
	async getTrackingAndEvents(
		{ deviceId, endDateTime, startDateTime, isSegmented = false }: TrailAndEvents,
		cancelToken?: CancelToken
	): Promise<ServiceResponse<TrackingHistoryWithEventsDto>> {
		const { data } = await axios.get<ServiceResponse<TrackingHistoryWithEventsDto>>(
			`/v2/trackingHistory/${deviceId}/tracking-events/dates/${startDateTime}/${endDateTime}`,
			{
				params: {
					'is-segmented': isSegmented,
				},
				cancelToken,
			}
		);
		return data;
	}
}
const TrackingHistory = new Service();

export default TrackingHistory;
